export default {
  "Algiers": { colour: "black" },
  "Atlanta": { colour: "blue" },
  "Baghdad": { colour: "black" },
  "Bangkok": { colour: "red" },
  "Beijing": { colour: "red" },
  "Bogota": { colour: "yellow" },
  "Buenos Aries": { colour: "yellow" },
  "Cairo": { colour: "black" },
  "Chennai": { colour: "black" },
  "Chicago": { colour: "blue" },
  "Delhi": { colour: "black" },
  "Essen": { colour: "blue" },
  "Ho Chi Minh City": { colour: "red" },
  "Hong Kong": { colour: "red" },
  "Istanbul": { colour: "black" },
  "Jakarta": { colour: "red" },
  "Johannesburg": { colour: "yellow" },
  "Karachi": { colour: "black" },
  "Khartoum": { colour: "yellow" },
  "Kinshasa": { colour: "yellow" },
  "Kolkata": { colour: "black" },
  "Lagos": { colour: "yellow" },
  "Lima": { colour: "yellow" },
  "London": { colour: "blue" },
  "Los Angeles": { colour: "yellow" },
  "Madrid": { colour: "blue" },
  "Manila": { colour: "red" },
  "Mexico City": { colour: "yellow" },
  "Miami": { colour: "yellow" },
  "Milan": { colour: "blue" },
  "Montreal": { colour: "blue" },
  "Moscow": { colour: "black" },
  "Mumbai": { colour: "black" },
  "New York": { colour: "blue" },
  "Osaka": { colour: "red" },
  "Paris": { colour: "blue" },
  "Riyadh": { colour: "black" },
  "San Francisco": { colour: "blue" },
  "Santiago": { colour: "yellow" },
  "Sao Paulo": { colour: "yellow" },
  "Seoul": { colour: "red" },
  "Shanghai": { colour: "red" },
  "St. Petersburg": { colour: "blue" },
  "Sydney": { colour: "red" },
  "Taipei": { colour: "red" },
  "Tehran": { colour: "black" },
  "Tokyo": { colour: "red" },
  "Washington": { colour: "blue" }
};



// WEBPACK FOOTER //
// ./src/all-cities.js